import React, {FC} from "react"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"
import {ButtonLink} from "@irati/ui/src/Link"

interface Props extends InjectIntl {
  pdf?: string
}

const DownloadPdf: FC<Props> = ({pdf, formatMessage}) => {
  if (!pdf) return null
  return (
    <ButtonLink primary full href={pdf} target="_blank" alt={formatMessage({id: "perks.components.tickets.downloadPdfText"})}>
      <Icon icon={IconTypes.newTab} marginRight />
      <FormattedMessage id="perks.components.tickets.downloadPdfText" />
    </ButtonLink>
  )
}

export default injectIntl(DownloadPdf)
